import request from '../../../../api/request';
import {
  EducationalInformation,
  OtherStudies,
} from '../parts/educationalInformation/types';

const EDUCATIONAL_INFORMATION = {
  GET_POSTULANT_EDUCATIONAL_INFORMATION: (studentId: string | number) =>
    `teacher-portal/student-file/educational-background/${studentId}`,
  GET_OTHER_STUDIES: (studentId: string | number) =>
    `teacher-portal/student-file/educational-background/other-studies/${studentId}`,
};

export const getPostulantEducationalInformation = (
  studentId: string | number,
) => {
  return request<EducationalInformation>(
    EDUCATIONAL_INFORMATION.GET_POSTULANT_EDUCATIONAL_INFORMATION(studentId),
  );
};

export const getOtherStudies = (
  postulantId: string | number,
  items: number = 10,
  page: number = 0,
) => {
  return request<OtherStudies>(
    EDUCATIONAL_INFORMATION.GET_OTHER_STUDIES(postulantId),
    {
      method: 'get',
      params: {
        items_per_page: items,
        page,
      },
    },
  );
};
